import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import SuggestDiscount from '../../resolution/suggestDiscount.jsx';

import { suggestDiscount } from '../payment/paymentActions.js';
import Page from '../../page.jsx';
import { data as agreementDataPropTypes } from '../../agreementPropTypes.js';
import partnerPropTypes from '../../partnerPropTypes.js';
import paymentPropTypes from '../../paymentPropTypes.js';
import safeTradePropTypes from '../../safeTradePropTypes.js';
import userPropTypes from '../../userPropTypes.js';
import { trackEvent } from '../../../services/trackingService.js';

class SuggestDiscountPage extends PureComponent {
    constructor() {
        super();
        this.handleClickSendSuggestion = this.handleClickSendSuggestion.bind(
            this
        );
    }

    componentDidMount() {
        trackEvent(
            'trade.buyer-does-not-approve-item.buyer-opens-suggest-discount-form'
        );
    }

    handleClickSendSuggestion({ discount }) {
        const { partner, payment, safeTrade } = this.props;
        const partnerSuggestedCurrentDiscount =
            payment.data.performedBy === 'SELLER';

        this.props.dispatch(
            suggestDiscount({
                itemId: safeTrade.itemId,
                itemType: safeTrade.itemType,
                partnerId: partner.id,
                discount,
                partnerSuggestedCurrentDiscount,
            })
        );
    }

    render() {
        const { agreement, partner, payment, safeTrade, user } = this.props;

        return (
            <Page heading="Foreslå et passende prisavslag">
                <SuggestDiscount
                    agreement={agreement}
                    cancelLink="/losning/noe-er-galt-med-varen"
                    enableConfirm={!payment.loading}
                    feePercentage={safeTrade.feePercentage}
                    onConfirm={this.handleClickSendSuggestion}
                    partner={partner}
                    payment={payment}
                    role={user.role}
                />
            </Page>
        );
    }
}

SuggestDiscountPage.propTypes = {
    agreement: agreementDataPropTypes.isRequired,
    dispatch: PropTypes.func.isRequired,
    partner: partnerPropTypes.isRequired,
    payment: paymentPropTypes.isRequired,
    safeTrade: safeTradePropTypes.isRequired,
    user: userPropTypes.isRequired,
};

function mapStateToProps(state) {
    return {
        agreement: state.agreement.data,
        partner: state.partner,
        payment: state.payment,
        safeTrade: state.safeTrade,
        user: state.user,
    };
}

export default connect(mapStateToProps)(SuggestDiscountPage);



// WEBPACK FOOTER //
// ./safeTrade/buyer/resolution/suggestDiscountPage.jsx